import { formatMoney } from '../formatting/money'

/**
 * Formats a year delta with direction:
 *   +1 → "1 year later", -3 → "3 years sooner".
 * Pluralization on |diff| === 1.
 */
export const formatYearsDelta = (diff: number): string => {
  const abs = Math.abs(diff)
  const unit = abs === 1 ? 'year' : 'years'
  const direction = diff > 0 ? 'later' : 'sooner'
  return `${abs} ${unit} ${direction}`
}

/**
 * Formats a money delta as compact currency plus its percentage of baseline:
 *   +$8,400 against baseline 84,000 → "$8K (10%)".
 * The chevron in the header conveys direction; sign is dropped here.
 *
 * A baseline of zero has no percentage to give — every change from nothing is an
 * infinite one — so the amount goes out alone rather than as "(Infinity%)". Real
 * for a year the baseline owed no tax, or set nothing aside, and the scenario
 * does.
 */
export const formatMoneyDelta = (mDiff: number, baseline: number): string => {
  const amount = formatMoney(Math.abs(mDiff), 'compact')
  if (baseline === 0) return amount
  const pct = Math.abs(Math.round((mDiff / baseline) * 100))
  return `${amount} (${pct}%)`
}
